import React, { Component, Fragment } from 'react';
import { Button } from 'semantic-ui-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class ButtonGroup extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.string,
          PropTypes.number,
        ]),
      })
    ),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    onChange: () => {},
  };

  render() {
    const { options, value, label, className, onChange, disabled } = this.props;

    const buttonGroupClass = classNames(className, 'btn-group--active-group');

    return (
      <Fragment>
        {label && <label>{label}</label>}
        <Button.Group basic className={buttonGroupClass}>
          {options.map((option, i) => {
            return (
              <Button
                basic
                active={value === option.value}
                disabled={disabled}
                className="white"
                key={i}
                onClick={e => onChange(e, option.value)}
              >
                {option.label}
              </Button>
            );
          })}
        </Button.Group>
      </Fragment>
    );
  }
}

export { ButtonGroup };



// WEBPACK FOOTER //
// ./src/common/Components/ButtonGroup/ButtonGroup.js